import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { SessionDataService } from 'inova-front-core/session';
import { ENTITY_DEFAULT_RENDER_STRING, ENTITY_QUESTION_PDF_KEYS } from 'inova-front-core/constants';
import { MobileQuery } from 'inova-front-core/helpers/clases';

import { InovaCommonGraphqlApi } from 'inova-front-core/helpers/services/http';
import { Entity, EntityAdditionalInfoItem, Form, Question, QuestionType } from 'inova-front-core/models';
import { zip } from 'rxjs';
import { DelimitationViewComponent } from '../delimitation-view/delimitation-view.component';
import { AnnexesViewComponent } from '../annexes-view/annexes-view.component';
import { CommonHelper,InovaMapHeper } from 'inova-front-core/helpers/clases';

@Component({
  selector: 'inova-entity-data',
  templateUrl: './entity-data.component.html',
  styleUrls: ['./entity-data.component.scss']
})
export class EntityDataComponent extends MobileQuery implements OnInit {


  @Input() entityId: string | number="";

  hideBasicInfo: boolean = false;
  entity: Entity | undefined;
  geolocation: any={};
  additionalInfo: EntityAdditionalInfoItem[]=[];
  additionalInfoQuestions:Question[]=[];

  entitieInformation: any[] = [];
  entityQuestions: any[] = [];
  excludedQuestions: any[] = [];
  loading: boolean = true;
  excludeProfessionalFields=false;

  questionTypes=QuestionType;

  areaAnswer: string = '';

  constructor(private sanitizer: DomSanitizer,
    private commonApiService: InovaCommonGraphqlApi,
    private sessionService:SessionDataService,
    private dialog: MatDialog) {
      super()
     }

  ngOnInit(): void {
    if(this.sessionService.getUserRole() === "productor"){
      this.excludeProfessionalFields=true;
    }
    let entityId=this.entityId;
    if(typeof entityId === 'number'){
      entityId=CommonHelper.intToGraphId("EntidadNode",entityId);
    }
    const requests = [
      this.commonApiService.getEntityById(entityId),
      this.commonApiService.getClientInfoRule()
    ]
    zip(...requests).subscribe((data:any[])=>{
      this.loading=false;
      this.setClientInfoRule(data[1]);
      this.setEntityData(data[0]);
    })
  }

  setClientInfoRule(form:Form) {
    if (form?.metadata?.HideBasicInfoIT) {
      this.hideBasicInfo = true;
    }
    let questions=form.capituloSet[0]?.preguntaSet || [];
    questions.forEach((x:Question)=>{
      x.id=CommonHelper.getIdFromGraphId(x.id);
      try {
        x.metadata = JSON.parse(x.metadata);
      } catch (error) {
        x.metadata = {};
      }
    });
    this.additionalInfoQuestions=questions;
    this.excludedQuestions = questions.filter(x => x.metadata?.ProfessionalField).map(y => y.id)
  }

  setEntityData(entity:Entity){
    this.entity=entity;
    if(this.entity?.geolocalizacion && typeof this.entity.geolocalizacion === 'string'){
      this.geolocation = JSON.parse(this.entity.geolocalizacion);
    }
    if(this.entity?.informacionGeneral){
      if(typeof this.entity.informacionGeneral === 'string'){
        this.additionalInfo = JSON.parse(this.entity.informacionGeneral);
      }
      else{
        this.additionalInfo = this.entity.informacionGeneral;
      }
      this.additionalInfo.forEach((item:EntityAdditionalInfoItem) => {
        const questionData=this.additionalInfoQuestions.find(x=>x.id==item.pregunta.pk);
        item.pregunta.metadato=questionData?.metadata || {};
        item.pregunta.orden=questionData?.orden || 0;
      });
      if(this.excludeProfessionalFields){
        this.additionalInfo=this.additionalInfo.filter(x=>!this.excludedQuestions.some(y=>y==x.pregunta.pk));
      }
      this.additionalInfo.sort((a,b)=>a.pregunta.orden>b.pregunta.orden?1:-1);
    }
    this.loadEntityQuestions();
  }
 
  loadEntityQuestions() {
    let entityQuestions = this.additionalInfo.filter(x => x.pregunta.tipo === QuestionType.Entity);
    const requests=entityQuestions.map(question=>{
      let entityId=CommonHelper.intToGraphId("EntidadNode",question.respuesta_tipo.valor);
      return this.commonApiService.getEntityById(entityId);
    });
    if(requests.length===0){
      this.loading=false;
    }
    zip(...requests).subscribe((data:Entity[])=>{
      this.loading=false;
      let index=0;
      for(let entity of data){
        this.entityQuestions.push({
          entityId: CommonHelper.getIdFromGraphId(entity.id || ""),
          entityName:entity.nombre,
          entityOwnerName:entity.productor.persona.nombre,
          entityOwnerLastName:entity.productor.persona.apellido ? entity.productor.persona.apellido : '',
          entityOwnerPhone:entity.productor.persona.telefono,
          entityOwnerEmail:entity.productor.persona.email,
          entityOwnerId:entity.productor.persona.cedula,
          value:entityQuestions[index].respuesta_tipo.valor
      })
      index++;
      }
      this.replaceEntityTextValues();
    });
  }

  replaceEntityTextValues(){
    this.additionalInfo.filter(x=>x.pregunta.tipo===QuestionType.Entity).forEach(item=>{
      const entityInfo=this.entityQuestions.find(x=>x.value==item.respuesta_tipo.valor);
      if(entityInfo){
        let textString = ENTITY_DEFAULT_RENDER_STRING;
        if (item.pregunta.metadato && item.pregunta.metadato.TextValue) {
          textString = item.pregunta.metadato.TextValue;
        }
        let entity_pdf_keys:any = ENTITY_QUESTION_PDF_KEYS;
        Object.keys(entity_pdf_keys).forEach(key => {
          while (textString.indexOf(key) !== -1) {
            let valueToReplace = entityInfo[entity_pdf_keys[key]];
            if (valueToReplace !== null && valueToReplace !== undefined && valueToReplace.toLowerCase() !== "n/a") {
              textString = textString.replace(key, valueToReplace)
            }
            else {
              textString = textString.replace(key, "");
            }
          }
        });
        item.respuesta_tipo.valor=textString;
      }
      else{
        item.respuesta_tipo.valor="";
      }
    })
  }

  existsEntitieLocation() {
    return this.entity?.geolocalizacion && this.entity.geolocalizacion.length > 0
  }

  getLocationLink(geolocation:any) {
    if(geolocation.lat && geolocation.lng){
      return this.sanitizer.bypassSecurityTrustUrl(`https://www.google.com/maps/?q=${geolocation.lat},${geolocation.lng}`);
    }
    return "javascript:void(0)";
  }

  getLocationLinkByPoint(point:string) {
    return this.getLocationLink(InovaMapHeper.getPositionByPoint(point));
  }

  seeDelimitation(data:EntityAdditionalInfoItem){
    this.dialog.open(DelimitationViewComponent, {
      width: this.mobileQuery?.matches ? '360px' : '800px',
      data: { points: data.respuesta_tipo.valor, title: data.pregunta.descripcion},
      maxHeight: '90vh',
    })
  }

  getValueFromQuestion(question:EntityAdditionalInfoItem) {
    let answer = question.respuesta_tipo && question.respuesta_tipo.valor;
    if (!answer) {
      return "";
    }
    if (Array.isArray(answer)) {
      return answer.map(x => x.descripcion).join(", ")
    }
    if(question.pregunta.tipo===QuestionType.Currency || question.pregunta.tipo===QuestionType.Numeric){
      return CommonHelper.formatCurrency(answer);
    }
    return (answer.descripcion) ? answer.descripcion : answer.toString()
  }

  getValueForAreaQuestion(question:EntityAdditionalInfoItem) {
    let answer = question.respuesta_tipo.valor;
    if (!answer) {
      return "";
    }
    answer = answer.replace(/\\\\n/g, "<br>");
    answer = answer.replace(/\\n/g, "<br>");
    return answer;
  }

  seeAnnexes(item:EntityAdditionalInfoItem){
    this.dialog.open(AnnexesViewComponent, {
      width: this.mobileQuery?.matches ? '360px' : '800px',
      data: { value: item.respuesta_tipo.valor, title: item.pregunta.descripcion},
      maxHeight: '90vh',
    })
  }

}
